<template>
<router-link :to="item.link.url" class="slide" :style="'background-image: url(' + item.bg.url + ');'">
    <div class="columns is-marginless is-mobile">
        <div class="column col-placeholder"></div>
        <div class="column col-text">
            <h2 class="title is-1">{{item.title}}</h2>
            <div class="content" v-html="item.content"></div>
        </div>
    </div>
</router-link>
</template>

<script>
export default {
    name    :   'Slide',
    props   :   ['item']
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/Slide.vue